export const SET_LOGIN_USER = 'SET_LOGIN_USER'
export const CLEAR_LOGIN_USER = 'CLEAR_LOGIN_USER'

export const SET_LOCALSTORAGE = 'SET_LOCALSTORAGE'
